import React from 'react'

const ArticleV2BackgroundGradient = ({data}) => {
    if (!data.gradientColors) return null;

    return (
        <div>
            <style jsx>{`
                div {
                    background-image: linear-gradient(transparent, ${data.gradientColors[0]}, ${data.gradientColors[1]});
                    // height: 2000px;
                    position: absolute;
                    top: 0;
                    left: 0;
                    height: 100%;
                    width: 100%;
                    z-index: 0;
                    pointer-events: none;
                }
            `}</style>
        </div>
    )
}

export default ArticleV2BackgroundGradient